/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as GridGalleryIcon } from "assets/images/icons/components/gallery-style-grid.svg";
import { ReactComponent as CollageGalleryIcon } from "assets/images/icons/components/gallery-style-masonry.svg";
import { ReactComponent as SliderGalleryIcon } from "assets/images/icons/components/gallery-style-slider.svg";
import { ReactComponent as FilmstripGalleryIcon } from "assets/images/icons/components/gallery-style-thumbnail.svg";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme) => ({
    galleryTypeContainer: {
        width: "100%",
        display: "flex",
        flexWrap: "nowrap",
    },
    type: {
        cursor: "pointer",
        flex: "0 0 60px",
        marginRight: theme.spacing(1.5),
        "& svg": {
            "& path, & rect": {
                fill: "#b4b4b4",
            },
            "& rect:last-child": {
                fill: "rgba(255, 255, 255, 0)",
                stroke: "#b4b4b4",
            },
        },
        "&.selected": {
            "& svg": {
                "& path, & rect": {
                    fill: "#0E7490",
                },
                "& rect:last-child": {
                    fill: "rgba(255, 255, 255, 0)",
                    stroke: "#0E7490",
                },
            },
        },
    },
}));

const SelectGalleryStyle = (props) => {
    
    const {
        galleryType,
        onChange
    } = props || {};
    
    const classes = useStyles();
    
    const chooseGalleryType = (event, galleryType) => {
        onChange(galleryType);
    };
    
    const IMAGE_GALLERY_TYPES = {
        FILMSTRIP: "thumbnail",
        CAROUSEL: "slider",
        GRID: "grid",
        COLLAGE: "masonry",
    };
    const SELECTED = "selected";

    return (
        <div className={classes.galleryTypeContainer}>
            {/*  Filmstrip  */}
            <div
                className={`${classes.type} ${galleryType === IMAGE_GALLERY_TYPES.FILMSTRIP ? SELECTED : ""}`}
                onClick={(e) => chooseGalleryType(e, IMAGE_GALLERY_TYPES.FILMSTRIP)}
            >
                <FilmstripGalleryIcon />
            </div>
            {/*  Carousel  */}
            <div
                className={`${classes.type} ${galleryType === IMAGE_GALLERY_TYPES.CAROUSEL ? SELECTED : ""}`}
                onClick={(e) => chooseGalleryType(e, IMAGE_GALLERY_TYPES.CAROUSEL)}
            >
                <SliderGalleryIcon />
            </div>
            {/*  Grid  */}
            <div
                className={`${classes.type} ${galleryType === IMAGE_GALLERY_TYPES.GRID ? SELECTED : ""}`}
                onClick={(e) => chooseGalleryType(e, IMAGE_GALLERY_TYPES.GRID)}
            >
                <GridGalleryIcon />
            </div>
            {/*   Collage  */}
            <div
                className={`${classes.type} ${galleryType === IMAGE_GALLERY_TYPES.COLLAGE ? SELECTED : ""}`}
                onClick={(e) => chooseGalleryType(e, IMAGE_GALLERY_TYPES.COLLAGE)}
            >
                <CollageGalleryIcon />
            </div>
        </div>
    );
};

export { SelectGalleryStyle };
